import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  FormControl,
  DialogContentText,
  OutlinedInput,
  InputLabel,
  FormHelperText,
} from '@material-ui/core';

export const getDefaultState = () => ({
  name: '',
  validation: {
    hasChanged: false,
    name: {
      hasChanged: false,
      isValid: true,
      message: 'Please provide a valid name (between 2 and 50 characters in length).',
    },
  },
});

export class CreateTagModalComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = getDefaultState();
  }

  handleNameChange = (e) => {
    const changedValue = e.target.value;
    const isValid = changedValue !== null && changedValue !== undefined
    && changedValue.length >= 2 && changedValue.length <= 50;
    this.setState((prevState) => ({
      name: changedValue,
      validation: {
        ...prevState.validation,
        name: {
          hasChanged: true,
          isValid,
          message: prevState.validation.name.message,
        },
      },
    }));
  }

  checkFieldsValid = () => {
    let validFields = true;
    if (!this.state.validation.name.hasChanged || !this.state.validation.name.isValid) {
      validFields = false;
      this.setState((prevState) => ({
        validation: {
          ...prevState.validation,
          name: {
            hasChanged: false,
            isValid: false,
            message: prevState.validation.name.message,
          },
        },
      }));
    }

    return validFields;
  }

  handleCreateTag = () => {
    if (this.checkFieldsValid()) {
      this.props.onAddTag(this.state.name, this.props.parentTagId);
      this.setState(getDefaultState());
      this.props.handleCloseModal();
    }
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.handleCloseModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Create Tag</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Create a new tag by providing a name.
          </DialogContentText>
          <FormControl
            error={!this.state.validation.name.isValid}
            margin="normal"
            fullWidth
            variant="outlined"
          >
            <InputLabel
              htmlFor="tag-name"
            >Name
            </InputLabel>
            <OutlinedInput
              id="name"
              value={this.state.name}
              autoFocus
              onChange={this.handleNameChange}
              labelWidth={45}
            />
            <FormHelperText>
              {
                !this.state.validation.name.isValid
                && this.state.validation.name.message
              }
            </FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleCloseModal}>
            Cancel
          </Button>
          <Button onClick={this.handleCreateTag} color="primary" variant="contained">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

CreateTagModalComponent.propTypes = {
  isOpen: PropTypes.bool,
  parentTagId: PropTypes.number,
  handleCloseModal: PropTypes.func,
  onAddTag: PropTypes.func,
};

CreateTagModalComponent.defaultProps = {
  isOpen: false,
  parentTagId: null,
  handleCloseModal: () => {},
  onAddTag: () => {},
};

export default connect(
  null,
  null,
)(withStyles({}, { withTheme: true })(CreateTagModalComponent));
